<template>
  <nav aria-label="Page navigation example">
    <ul class="pagination flex-wrap">
      <li
        class="page-item"
        :class="{'disabled':currentPage===1}"
        @click="changePageHandler(currentPage-1)"
      >
        <a
          class="page-link previous"
          href="javascript:;"
          aria-label="Previous"
        />
      </li>
      <li
        v-for="page in pages"
        :key="page"
        class="page-item mb-2"
        @click="changePageHandler(page)"
      >
        <a
          class="page-link page-link-item"
          href="javascript:;"
          :class="{'active':page===currentPage}"
        >{{ page }}</a>
      </li>
      <li
        class="page-item"
        :class="{'disabled':currentPage>=pages}"
        @click="changePageHandler(currentPage+1)"
      >
        <a
          class="page-link next"
          href="javascript:;"
          aria-label="Next"
        />
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pages: {
      type: Number,
      default: 1
    }
  },
  setup (props, { emit }) {
    const changePageHandler = (index) => {
      emit('changePage', index)
    }

    return {
      changePageHandler
    }
  }
}
</script>

<style lang="scss" scoped>
.page-item {
  display: flex;
  align-items: center;
  margin: 0 0.5rem;
}
.page-link {
  border: none;
  color: black;
}

.page-link-item {
  border-radius: 50%;
  display: flex;
  width: 2rem;
  height: 2rem;
  justify-content: center;
  align-items: center;
  border: 1px solid #D0D0D0;
  color:#D0D0D0;

  &.active{
    border: 1px solid black;
    background-color: black;
    color: white;
  }
}
.previous {
  background: url("../assets/image/Vector.svg") no-repeat;
  background-position: center center;
}
.next {
  background: url("../assets/image/Vector2.svg") no-repeat;
  background-position: center center;
}
.previous {
  background: url("../assets/image/Vector.svg") no-repeat;
  background-position: center center;
}

.disabled {
  pointer-events: none;
  cursor: default;
}
</style>
